var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormazione(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31276 18C5.31155 18 4.5 18.8394 4.5 19.8749C4.5 20.9104 5.31172 21.75 6.31276 21.75H20.25V18H6.31276Z",
    fill: "#EFEDEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3331 21.6747C5.34559 21.6747 4.54515 20.8584 4.54515 19.8518C4.54515 18.8448 5.34576 18.0287 6.3331 18.0287H20.2275C20.6542 18.0287 21 17.676 21 17.241V1.53775C21 1.10259 20.6542 0.75 20.2275 0.75H6.09906C4.38739 0.75 3 2.16466 3 3.9096V20.0904C3 21.8353 4.38756 23.25 6.09906 23.25H20.2275C20.6542 23.25 21 22.8974 21 22.4622C21 22.0273 20.6542 21.6747 20.2275 21.6747H6.3331Z",
    fill: "#FD6F71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2275 21.6747H6.3331C5.34559 21.6747 4.54515 20.8584 4.54515 19.8518C4.54515 18.8448 5.34576 18.0287 6.3331 18.0287H7.23574V0.75H6.09906C4.38739 0.75 3 2.16466 3 3.9096V20.0904C3 21.8353 4.38756 23.25 6.09906 23.25H20.2275C20.6542 23.25 21 22.8974 21 22.4622C21 22.0273 20.6542 21.6747 20.2275 21.6747Z",
    fill: "#FD6F71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormazione);
export default __webpack_public_path__ + "static/media/formazione.17e96f58b298c6f9595ecd0bcf688fb8.svg";
export { ForwardRef as ReactComponent };